import React from 'react';

import Field from 'components/Field';
import styles from './ManageModalBadge.module.scss';

function ManageModalBadge({ heading, data }) {
  return (
    <div className={styles.badge}>
      <Field
        label={heading}
        labelClassName="row align-c justify-c"
      >
        <div className={styles.dateBadge}>{data}</div>
      </Field>
    </div>
  );
}

export default ManageModalBadge;
